<template>
  <div>
    <v-card>
      <SkeletonTable
        :loading="loading"
        :first-load="firstLoad"
        :cols="6"
        :rows="15"
      />
      <v-data-table
        :headers="headers"
        :items="filteredPersons"
        :search="search"
        :custom-filter="filterItems"
        :items-per-page="30"
        :footer-props="{
          itemsPerPageOptions: [15, 30, -1],
          itemsPerPageText: $t('table.itemsPerPageText')
        }"
        :loading="loading"
        :loading-text="$t('table.loading')"
        v-show="!firstLoad"
        sort-by="preferred_name.given_name"
        class="table-cursor"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
              class="mr-2 mr-md-5"
            />

            <v-menu offset-x>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="search == '' ? 'grey' : 'orange'"
                  :outlined="search != ''"
                  :text="search == ''"
                  v-bind="attrs"
                  v-on="on"
                  class="mx-0 mx-lg-2"
                  icon
                >
                  <v-icon
                   v-if="search == ''"
                  >
                    mdi-filter-outline
                  </v-icon>
                  <v-icon
                   v-else
                  >
                    mdi-filter-check
                  </v-icon>
                </v-btn>
              </template>
              <v-list>

                <!-- vinculation:@ -->
                <v-list-item @click.stop>
                  <v-menu offset-x>
                    <template v-slot:activator="{ on, attrs }">
                      <v-list-item-title
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon
                          :color="search.includes(`vinculation:`) ? 'orange' : 'grey'"
                        >
                          mdi-account
                        </v-icon>
                        Estado de relación con el centro
                        <v-icon class="grey--text text--lighten-1 float-right">mdi-menu-down</v-icon>
                      </v-list-item-title>
                    </template>
                    <v-list>
                      <v-list-item
                        link
                        @click="filterSearchAdd(`vinculation:@`, st)"
                        :key="st"
                        v-for="st in ['ok', 'warn', 'expired', 'no']"
                      >
                        <v-list-item-title>
                          <v-icon
                            v-if="search.includes(`vinculation:${st}`)"
                          >
                            mdi-check-circle
                          </v-icon>
                          <v-icon
                            v-else
                          >
                            mdi-circle-small
                          </v-icon>
                          {{ $t(`table.tooltip.vinculation_${st}`) }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item>

                <!-- account:@ -->
                <v-list-item @click.stop>
                  <v-menu offset-x>
                    <template v-slot:activator="{ on, attrs }">
                      <v-list-item-title
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon
                          :color="search.includes(`account:`) ? 'orange' : 'grey'"
                        >
                          mdi-lock
                        </v-icon>
                        Estado de cuenta de usuario
                        <v-icon class="grey--text text--lighten-1 float-right">mdi-menu-down</v-icon>
                      </v-list-item-title>
                    </template>
                    <v-list>
                      <v-list-item
                          link
                          @click="filterSearchAdd(`account:@`, st)"
                          :key="st"
                          v-for="st in ['ok', 'warn', 'expired', 'no-username']"
                        >
                        <v-list-item-title>
                          <v-icon
                            v-if="search.includes(`account:${st}`)"
                          >
                            mdi-check-circle
                          </v-icon>
                          <v-icon
                            v-else
                          >
                            mdi-circle-small
                          </v-icon>
                          {{ $t(`table.tooltip.account_${st}`) }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item>


                <!-- workplace:@ -->
                <v-list-item @click.stop>
                  <v-menu offset-x>
                    <template v-slot:activator="{ on, attrs }">
                      <v-list-item-title
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon
                          :color="search.includes(`workplace:`) ? 'orange' : 'grey'"
                        >
                          mdi-archive
                        </v-icon>
                        Estado de lugar de trabajo
                        <v-icon class="grey--text text--lighten-1 float-right">mdi-menu-down</v-icon>
                      </v-list-item-title>
                    </template>
                    <v-list>
                      <v-list-item
                        link
                        @click="filterSearchAdd(`workplace:@`, st)"
                        :key="st"
                        v-for="st in ['ok', 'warn', 'expired', 'no']"
                      >
                        <v-list-item-title>
                          <v-icon
                            v-if="search.includes(`workplace:${st}`)"
                          >
                            mdi-check-circle
                          </v-icon>
                          <v-icon
                            v-else
                          >
                            mdi-circle-small
                          </v-icon>
                          {{ $t(`table.tooltip.workplace_${st}`) }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item>

                <!-- relation-recent-@m -->
                <v-list-item @click.stop>
                  <v-menu offset-x>
                    <template v-slot:activator="{ on, attrs }">
                      <v-list-item-title
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon
                          :color="search.includes('relation-recent-') ? 'orange' : 'grey'"
                        >
                          mdi-calendar-account
                        </v-icon>
                        Nueva relación con el centro
                        <v-icon class="grey--text text--lighten-1 float-right">mdi-menu-down</v-icon>
                      </v-list-item-title>
                    </template>
                    <v-list>
                      <v-list-item
                        link
                        @click="filterSearchAdd('relation-recent-@m', n)"
                        :key="n"
                        v-for="n in [6,5,4,3,2,1]"
                      >
                        <v-list-item-title>
                          <v-icon
                            v-if="search.includes(`relation-recent-${n}m`)"
                          >
                            mdi-check-circle
                          </v-icon>
                          <v-icon
                            v-else
                          >
                            mdi-circle-small
                          </v-icon>
                          Hace {{ n }} meses o menos
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item>

                <!-- type:@ -->
                <v-list-item
                  :key="year"
                  v-for="year in ['current', thisyear, thisyear-1]"
                  @click.stop
                >
                <v-menu offset-x>
                    <template v-slot:activator="{ on, attrs }">
                      <v-list-item-title
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon
                          :color="search.includes(`type-${year}:`) ? 'orange' : 'grey'"
                        >
                          mdi-shape
                        </v-icon>
                        Tipo de relación <span v-if="year=='current'">actual</span><span v-else>en {{ year }}</span>
                        <v-icon class="grey--text text--lighten-1 float-right">mdi-menu-down</v-icon>
                      </v-list-item-title>
                    </template>
                    <v-list>
                      <v-list-item
                        :key="type"
                        v-for="type in ['permanent_linked_investigator', 'permanent_not_linked_investigator', 'collaborator_investigator', 'training_investigator', 'competitive_program_investigator', 'posdoc_investigator', 'stay_investigator', 'support_staff', 'other_starting', 'other_intern_collaboration', 'other_intern_summer', 'support_investigator', 'external_collaborator']"
                        link
                        @click="filterSearchAdd(`type-${year}:@`, type)"
                      >
                        <v-list-item-title>
                          <v-icon
                            v-if="search.includes(`type-${year}:${type}`)"
                          >
                            mdi-check-circle
                          </v-icon>
                          <v-icon
                            v-else
                          >
                            mdi-circle-small
                          </v-icon>
                          {{ $t(`vinculation.types.${type}`) }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item>


                <!-- category-$:@ -->
                <v-list-item
                  :key="year"
                  v-for="year in ['current', thisyear, thisyear-1]"
                  @click.stop
                >
                <v-menu offset-x :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                      <v-list-item-title
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon
                          :color="search.includes(`category-${year}:`) ? 'orange' : 'grey'"
                        >
                          mdi-account-multiple-outline
                        </v-icon>
                        Categoría <span v-if="year=='current'">actual</span><span v-else>en {{ year }}</span>
                        <v-icon class="grey--text text--lighten-1 float-right">mdi-menu-down</v-icon>
                      </v-list-item-title>
                    </template>
                    <v-list>
                      <v-list-item>
                        <v-list-item-title>
                          <div style="display: flex; align-items: center;">
                            <v-text-field
                              v-model="searchCategory"
                              variant="underline"
                              @keyup.enter="filterSearchAdd(`category-${year}:@`, searchCategory)"
                            ></v-text-field>
                            <v-btn
                              icon
                              @click="filterSearchAdd(`category-${year}:@`, searchCategory)"
                            >
                              <v-icon>mdi-check</v-icon>
                            </v-btn>
                          </div>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item>

                <!-- country:@ -->
                <v-list-item @click.stop>
                  <v-menu offset-x :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                      <v-list-item-title
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon
                          :color="search.includes(`country:`) ? 'orange' : 'grey'"
                        >
                          mdi-earth
                        </v-icon>
                        Nacionalidades
                        <v-icon class="grey--text text--lighten-1 float-right">mdi-menu-down</v-icon>
                      </v-list-item-title>
                    </template>
                    <v-list>
                      <v-list-item>
                        <v-list-item-title>
                          <div style="display: flex; align-items: center;">
                            <v-text-field
                              v-model="searchCountry"
                              variant="underline"
                              @keyup.enter="filterSearchAdd(`country:@`, searchCountry)"
                            ></v-text-field>
                            <v-btn
                              icon
                              @click="filterSearchAdd(`country:@`, searchCountry)"
                            >
                              <v-icon>mdi-check</v-icon>
                            </v-btn>
                          </div>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item>

                <!-- hidden -->
                <v-list-item
                  link
                  @click="filterSearchAdd('hidden','')"
                >
                  <v-list-item-title>
                    <v-icon
                      :color="search.includes('hidden') ? 'orange' : 'grey'"
                    >
                      mdi-eye-off
                    </v-icon>
                    Investigadores ocultos
                  </v-list-item-title>
                </v-list-item>

                <!-- is-admin -->
                <v-list-item
                  link
                  @click="filterSearchAdd('is-admin','')"
                >
                  <v-list-item-title>
                    <v-icon
                      :color="search.includes('is-admin') ? 'orange' : 'grey'"
                    >
                      mdi-shield-account
                    </v-icon>
                    Marcado como admin
                  </v-list-item-title>
                </v-list-item>

                <!-- no-areas -->
                <v-list-item
                  link
                  @click="filterSearchAdd('no-areas','')"
                >
                  <v-list-item-title>
                    <v-icon
                      :color="search.includes('no-areas') ? 'orange' : 'grey'"
                    >
                      mdi-alert
                    </v-icon>
                    Investigadores sin áreas
                  </v-list-item-title>
                </v-list-item>

                <!-- has-comment -->
                <v-list-item
                  link
                  @click="filterSearchAdd('has-comment','')"
                >
                  <v-list-item-title>
                    <v-icon
                      :color="search.includes('has-comment') ? 'orange' : 'grey'"
                    >
                      mdi-comment
                    </v-icon>
                    Investigadores con comentarios
                  </v-list-item-title>
                </v-list-item>
                
                <v-divider></v-divider>
                
                <v-list-item
                  link
                  @click="filterSearchClear()"
                >
                  <v-list-item-title>
                    <v-icon>
                      mdi-delete
                    </v-icon>
                    Borrar filtros
                  </v-list-item-title>
                </v-list-item>

              </v-list>
            </v-menu>

            <v-spacer />

            <v-btn
              color="primary"
              dark
              class=""
              @click="$router.push('/manage/edit/researchers/add')"
              ><v-icon class="mr-0 mr-sm-2">mdi-plus-thick</v-icon
              ><span class="d-none d-sm-inline">{{ $t("button.newItem") }}</span></v-btn
            >
          </v-toolbar>
        </template>
        <template v-slot:item.preferred_name.given_name="{ item }"
          >{{ item.preferred_name.given_name }}
          {{ item.preferred_name.family_name }}</template
        >

        <template v-slot:item.account_status="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon :color="accountIndicator(item.account_status).color"
                :aria-label="$t('table.tooltip.' + accountIndicator(item.account_status).tooltip)"
                v-bind="attrs" v-on="on">
                {{ accountIndicator(item.account_status).icon }}
              </v-icon>
            </template>
            {{ $t('table.tooltip.' + accountIndicator(item.account_status).tooltip) }}
          </v-tooltip>
        </template>


        <template v-slot:item.vinculation_status="{ item }" class="center">
          <v-tooltip
            v-if="item.vinculation_status !== null && item.vinculation_status.has_vinculation === true && item.vinculation_status.ends_soon === false"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="green"
                v-bind="attrs"
                v-on="on"
              >
                mdi-account-check
              </v-icon>
            </template>
            {{ $t('table.tooltip.vinculation_ok') }}
          </v-tooltip>
          <v-tooltip
            v-else-if="item.vinculation_status !== null && item.vinculation_status.has_vinculation === true && item.vinculation_status.ends_soon === true && item.vinculation_status.active_vinculation === true"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="orange"
                v-bind="attrs"
                v-on="on"
              >
                mdi-account-clock
              </v-icon>
            </template>
            {{ $t('table.tooltip.vinculation_warn') }}
          </v-tooltip>
          <v-tooltip
            v-else-if="item.vinculation_status === null || item.vinculation_status.has_vinculation === false"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="grey"
                v-bind="attrs"
                v-on="on"
              >
                mdi-account-remove
              </v-icon>
            </template>
            {{ $t('table.tooltip.vinculation_no') }}
          </v-tooltip>
          <v-tooltip
            v-else
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="red"
                v-bind="attrs"
                v-on="on"
              >
                mdi-account-alert
              </v-icon>
            </template>
            {{ $t('table.tooltip.vinculation_expired') }}
          </v-tooltip>
        </template>
        <template v-slot:item.workplace_status="{ item }" class="center">
          <v-tooltip
            v-if="item.workplace_status !== null && item.workplace_status.has_workplace === true && item.workplace_status.expires_soon === false && item.workplace_status.active_workplace === true"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="green"
                v-bind="attrs"
                v-on="on"
              >
                mdi-archive-check
              </v-icon>
            </template>
            {{ $t('table.tooltip.workplace_ok') }}
          </v-tooltip>
          <v-tooltip
            v-else-if="item.workplace_status !== null && item.workplace_status.has_workplace === true && item.workplace_status.expires_soon === true && item.workplace_status.active_workplace === true"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="orange"
                v-bind="attrs"
                v-on="on"
              >
                mdi-archive-clock
              </v-icon>
            </template>
            {{ $t('table.tooltip.workplace_warn') }}
          </v-tooltip>
          <v-tooltip
            v-else-if="item.workplace_status === null || item.workplace_status.has_workplace === false"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="grey"
                v-bind="attrs"
                v-on="on"
              >
                mdi-archive-remove
              </v-icon>
            </template>
            {{ $t('table.tooltip.workplace_no') }}
          </v-tooltip>
          <v-tooltip
            v-else
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="red"
                v-bind="attrs"
                v-on="on"
              >
                mdi-archive-alert
              </v-icon>
            </template>
            {{ $t('table.tooltip.workplace_expired') }}
          </v-tooltip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon text class="mr-2" color="primary" v-bind="attrs" v-on="on" :aria-label="$t('personInfo.title')" @click="infoPersonId = item.id; infoDialog = true">
                <v-icon>mdi-information-outline</v-icon>
              </v-btn>
            </template>
            {{ $t('personInfo.title') }}
          </v-tooltip>
          <v-btn
            icon
            text
            class="mr-2"
            color="primary"
            :to="`/manage/edit/researchers/edit/${item.id}`"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-icon color="red" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
    <PersonOverviewDialog v-model="infoDialog" :person-id="infoPersonId" :people="persons" @merged="personMerged" />
  </div>
</template>

<script>
import axios from "axios";
import SkeletonTable from "../../../components/reusables/SkeletonTable";
import filterSearchMixin from '../../../mixins/filterSearchMixin.js'
import { accountIndicator } from '../../../utils/accountStatus';
import PersonOverviewDialog from '../../../components/users/PersonOverviewDialog.vue';
export default {
  components: { SkeletonTable, PersonOverviewDialog },
  mixins: [filterSearchMixin],
  data() {
    return {
      thisyear: new Date().getFullYear(),
      search: "",
      infoPersonId: null,
      infoDialog: false,
      searchCategory: "",
      searchCountry: "",
      loading: true,
      firstLoad: true,
      persons: [],
      filteredPersons: []
    };
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t("title.investigator"),
          value: "preferred_name.given_name",
          width: "27%"
        },
        {
          text: this.$t("form.email"),
          value: "email[0]",
          width: "19%"
        },
        {
          text: this.$t("table.account"),
          value: "account_status",
          align: "center",
          width: "14%",
          sortable: false
        },
        {
          text: this.$t("table.vinculation"),
          value: "vinculation_status",
          align: "center",
          width: "14%",
          sortable: false
        },
        {
          text: this.$t("table.workplace"),
          value: "workplace_status",
          align: "center",
          width: "14%",
          sortable: false
        },
        {
          text: this.$t("actions"),
          value: "actions",
          width: "12%",
          align: "end",
          filterable: false,
          sortable: false
        }
      ];
    }
  },
  created() {
    this.initialize();
  },

  methods: {
    personMerged(result) {
      this.infoPersonId = result.target_id;
      this.initialize();
    },
    accountIndicator,
    filterItems(value, search, item) {
      const search_array = search
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .split(",")
        .map(x => x.trim());
      const today = new Date().toISOString().split('T')[0];
      const six_months_ago = new Date((new Date()).setMonth(new Date().getMonth() - 6)).toISOString().split('T')[0]; 
      const five_months_ago = new Date((new Date()).setMonth(new Date().getMonth() - 5)).toISOString().split('T')[0]; 
      const four_months_ago = new Date((new Date()).setMonth(new Date().getMonth() - 4)).toISOString().split('T')[0]; 
      const three_months_ago = new Date((new Date()).setMonth(new Date().getMonth() - 3)).toISOString().split('T')[0]; 
      const two_months_ago = new Date((new Date()).setMonth(new Date().getMonth() - 2)).toISOString().split('T')[0]; 
      const one_month_ago = new Date((new Date()).setMonth(new Date().getMonth() - 1)).toISOString().split('T')[0]; 
      const one_year_ago = new Date((new Date()).setFullYear(new Date().getFullYear() - 1)).toISOString().split('T')[0];
      const two_years_ago = new Date((new Date()).setFullYear(new Date().getFullYear() - 2)).toISOString().split('T')[0];
      const three_years_ago = new Date((new Date()).setFullYear(new Date().getFullYear() - 3)).toISOString().split('T')[0];
      const thisyear = today.split('-')[0];
      const categoryName = vinculation =>
        vinculation.category && vinculation.category.internal_name
          ? vinculation.category.internal_name
          : "";
      const customValue = (
        " fullname:" + 
        item.preferred_name.given_name +
        " " +
        item.preferred_name.family_name + 
        " givenname:" + 
        item.preferred_name.given_name +
        " familyname:" +
        item.preferred_name.family_name + 
        " document:" + 
        item.id_number.value +
        " gender:" +
        item.gender + 
        item.incharge.reduce((a, b) => a + " incharge:" + b, "") +
        " " + 
        item.email.reduce((a, b) => a + " email:" + b, "") +
        " " + 
        item.citicenship.filter(x => x !== "" && x !== "España").reduce((a, b) => a + " country:" + b, "") +
        " " + 
        item.vinculations.reduce((a, b) => a + " category:" + categoryName(b), "") +
        " " + 
        item.vinculations.reduce((a, b) => a + ((b.start_date <= today && b.end_date >= today ) ? " category-current:" + categoryName(b) : ""), "") +
        " " + 
        item.vinculations.reduce((a, b) => a + ((b.start_date >= six_months_ago && b.end_date >= today ) ? " relation-recent-6m " : ""), "") + " " + 
        item.vinculations.reduce((a, b) => a + ((b.start_date >= five_months_ago && b.end_date >= today ) ? " relation-recent-5m " : ""), "") + " " +
        item.vinculations.reduce((a, b) => a + ((b.start_date >= four_months_ago && b.end_date >= today ) ? " relation-recent-4m: " : ""), "") + " " +
        item.vinculations.reduce((a, b) => a + ((b.start_date >= three_months_ago && b.end_date >= today ) ? " relation-recent-3m " : ""), "") + " " +
        item.vinculations.reduce((a, b) => a + ((b.start_date >= two_months_ago && b.end_date >= today ) ? " relation-recent-2m " : ""), "") + " " +
        item.vinculations.reduce((a, b) => a + ((b.start_date >= one_month_ago && b.end_date >= today ) ? " relation-recent-1m " : ""), "") + " " +
        item.vinculations.reduce((a, b) => a + ((b.start_date <= new Date((new Date()).setFullYear(new Date().getFullYear() - 1, new Date().getMonth(), new Date().getDate() - 15)).toISOString().split('T')[0] && b.end_date >= today ) ? " relation-older-1y " : ""), "") + " " +
        item.vinculations.reduce((a, b) => a + ((b.start_date <= new Date((new Date()).setFullYear(new Date().getFullYear() - 2, new Date().getMonth(), new Date().getDate() - 15)).toISOString().split('T')[0] && b.end_date >= today ) ? " relation-older-2y " : ""), "") + " " +
        item.vinculations.reduce((a, b) => a + ((b.start_date <= new Date((new Date()).setFullYear(new Date().getFullYear() - 3, new Date().getMonth(), new Date().getDate() - 15)).toISOString().split('T')[0] && b.end_date >= today ) ? " relation-older-3y " : ""), "") + " " +
        item.vinculations.reduce((a, b) => a + ((b.start_date <= thisyear + "-12-31" && b.end_date >= thisyear + "-01-01" ) ? " category-" + thisyear + ":" + categoryName(b) : ""), "") +
        " " + 
        item.vinculations.reduce((a, b) => a + ((b.start_date <= (thisyear-1) + "-12-31" && b.end_date >= (thisyear-1) + "-01-01" ) ? " category-" + (thisyear-1) + ":" + categoryName(b) : ""), "") +
        " " + 
        item.vinculations.reduce((a, b) => a + ((b.start_date <= (thisyear-2) + "-12-31" && b.end_date >= (thisyear-2) + "-01-01" ) ? " category-" + (thisyear-2) + ":" + categoryName(b) : ""), "") +
        " " + 
        item.vinculations.reduce((a, b) => a + ((b.start_date <= (thisyear-3) + "-12-31" && b.end_date >= (thisyear-3) + "-01-01" ) ? " category-" + (thisyear-3) + ":" + categoryName(b) : ""), "") +
        " " + 
        item.vinculations.reduce((a, b) => a + ((b.start_date <= (thisyear-4) + "-12-31" && b.end_date >= (thisyear-4) + "-01-01" ) ? " category-" + (thisyear-4) + ":" + categoryName(b) : ""), "") +
        " " + 
        item.vinculations.reduce((a, b) => a + ((b.start_date <= (thisyear-5) + "-12-31" && b.end_date >= (thisyear-5) + "-01-01" ) ? " category-" + (thisyear-5) + ":" + categoryName(b) : ""), "") +
        " " + 
        item.vinculations.reduce((a, b) => a + " type:" + b.type, "") +
        " " +
        item.vinculations.reduce((a, b) => a + ((b.start_date <= today && b.end_date >= today ) ? " type-current:" + b.type : ""), "") +
        " " +
        item.vinculations.reduce((a, b) => a + ((b.start_date <= thisyear + "-12-31" && b.end_date >= thisyear + "-01-01" ) ? " type-" + thisyear + ":" + b.type : ""), "") +
        " " +
        item.vinculations.reduce((a, b) => a + ((b.start_date <= (thisyear-1) + "-12-31" && b.end_date >= (thisyear-1) + "-01-01" ) ? " type-" + (thisyear-1) + ":" + b.type : ""), "") +
        " " +
        item.vinculations.reduce((a, b) => a + ((b.start_date <= (thisyear-2) + "-12-31" && b.end_date >= (thisyear-2) + "-01-01" ) ? " type-" + (thisyear-2) + ":" + b.type : ""), "") +
        " " +
        item.vinculations.reduce((a, b) => a + ((b.start_date <= (thisyear-3) + "-12-31" && b.end_date >= (thisyear-3) + "-01-01" ) ? " type-" + (thisyear-3) + ":" + b.type : ""), "") +
        " " +
        item.vinculations.reduce((a, b) => a + ((b.start_date <= (thisyear-4) + "-12-31" && b.end_date >= (thisyear-4) + "-01-01" ) ? " type-" + (thisyear-4) + ":" + b.type : ""), "") +
        " " +
        item.vinculations.reduce((a, b) => a + ((b.start_date <= (thisyear-5) + "-12-31" && b.end_date >= (thisyear-5) + "-01-01" ) ? " type-" + (thisyear-5) + ":" + b.type : ""), "") +
        " account:" + accountIndicator(item.account_status).state +
        ( (item.vinculation_status !== null && item.vinculation_status.has_vinculation === true && item.vinculation_status.ends_soon === false) ? " vinculation:ok" : "") +
        ( (item.vinculation_status !== null && item.vinculation_status.has_vinculation === true && item.vinculation_status.ends_soon === true && item.vinculation_status.active_vinculation === true) ? " vinculation:warn" : "") +
        ( (item.vinculation_status === null || item.vinculation_status.has_vinculation === false) ? " vinculation:no" : "") +
        ( (item.vinculation_status !== null && item.vinculation_status.active_vinculation === false) ? " vinculation:expired" : "") +
        ( (item.workplace_status !== null && item.workplace_status.has_workplace === true && item.workplace_status.expires_soon === false && item.workplace_status.active_workplace === true) ? " workplace:ok" : "") +
        ( (item.workplace_status !== null && item.workplace_status.has_workplace === true && item.workplace_status.expires_soon === true && item.workplace_status.active_workplace === true) ? " workplace:warn" : "") +
        ( (item.workplace_status === null || item.workplace_status.has_workplace === false) ? " workplace:no" : "") +
        ( (item.workplace_status !== null && item.workplace_status.active_workplace === false) ? " workplace:expired" : "") +
        (item.hidden? " hidden" : "") +
        (item.is_admin? " is-admin" : "") +
        (item.research_areas.length === 0 ? " no-areas" : "") + 
        (item.comments? " has-comment " + item.comments : "")
      )
        .toString()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      return (
        customValue != null &&
        search_array != null &&
        typeof customValue === "string" &&
        search_array.every(function(search){ return customValue.indexOf(search) !== -1 })
      );
    },

    getNamePerson(item) {
      return (
        item.preferred_name.given_name + " " + item.preferred_name.family_name
      );
    },
    initialize() {
      let path = this.$store.state.endpoint + "/person";
      axios
        .get(path)
        .then(response => {
          this.filteredPersons = this.persons = response.data;
          this.loading = false;
          if (this.firstLoad) this.firstLoad = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    deleteItem(item) {
      if (confirm(this.$t("message.confirm.delete"))) {
        let path = this.$store.state.endpoint + "/person/" + item.id;
        axios
          .delete(path)
          .then(response => {
            const index = this.persons.indexOf(item);
            this.persons.splice(index, 1);
            this.$store.commit("alert", {
              color: "success",
              text: this.$t("message.correct.deleteItem")
            });
          })
          .catch(error => {
            console.log(error);
            this.$store.commit("alert", {
              color: "error",
              text: error.response
            });
          });
      }
    }
  }
};
</script>
